import classNames from "classnames";
import { FC } from "react";

interface DividerProps {
  className?: string;
  color?: string;
}

const Divider: FC<DividerProps> = (props) => {
  const { className, color = "#E3E7EB" } = props;
  return (
    <hr
      style={{ borderColor: color }}
      className={classNames("w-full", className)}
    />
  );
};

export default Divider;
